import { ChangeEvent, useEffect, useState } from 'react';
import { useGetAuftragMutation, useGetTermineMutation, useSaveCalendarEventIdMutation, useTerminMutation, useTerminStornoMutation } from '../../api/AuftragAPI';
import { useGetUserProfilesMutation } from '../../api/UserRoleAPI';
import { IAuftrag, IAuftragTerminResponse, IOnlyUserProfile } from '../../types/Types';
import { formatToEuroDateTime } from '../../util/DateUtils';

interface ComponentProps {
  refresh?: () => void;
  uid_auftrag: string | undefined;
  statusChanged: () => void;
}

/**
 * @author noone
 */
const AuftragTerminAendernComponent: React.FC<ComponentProps> = (props) => {

  //const dispatch = useDispatch<AppDispatch>();

  const [terminStornoAPI] = useTerminStornoMutation();
  const [getAuftragAPI] = useGetAuftragMutation();
  const [setTerminAPI] = useTerminMutation();
  const [getUserProfiles] = useGetUserProfilesMutation();
  const [getAuftragTermineAPI] = useGetTermineMutation();
  const [saveCalendarEventIdAPI] = useSaveCalendarEventIdMutation();

  const [auftrag, setAuftrag] = useState<IAuftrag>();

  const [termineVonAusfuehrenden, setTermineVonAusfuehrenden] = useState<IAuftragTerminResponse[]>([]);

  const [minute, setMinute] = useState<string>("00");
  const [stunde, setStunde] = useState<string>("07");
  const [ausfuehrender, setAusfuehrender] = useState<IOnlyUserProfile>();
  const [ausfuehrenderUid, setAusfuehrenderUid] = useState<string>();
  const [termindatum, setTermindatum] = useState<string>();
  const [calendarId, setCalendarId] = useState<string>();
  const [userProfiles, setUserProfiles] = useState<IOnlyUserProfile[]>([]);

  const handleChangeTermindatum = (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    setTermindatum(e.target.value);
  }

  const lade = () => {

    if (!props.uid_auftrag) return;

    getAuftragAPI(props.uid_auftrag).unwrap()
      .then(data => setAuftrag(data))
      .catch((error) => console.error("Fehler :", error))
      ;
  }

  const stornoTermin = (uid: string) => {
    terminStornoAPI(uid).unwrap()
      .then(() => {

        //checkCalendarGoogleToken();

        /*if (googleToken !== null && googleToken !== undefined &&
          calendarId !== null && calendarId !== undefined &&
          auftrag?.calendarEventId !== null) {
          try {
            axios.delete(
              `https://www.googleapis.com/calendar/v3/calendars/${calendarId}/events/${auftrag?.calendarEventId}`,
              {
                headers: { Authorization: `Bearer ${googleToken}` }
              }).catch(error => {
                if (axios.isAxiosError(error)) {
                  //const status = error.response?.status;
                }
                console.error(error);
              });

          } catch (error) {
            console.error("Fehler beim Löschen des Calendar Events:", error);
          } finally {
            saveCalendarEventIdAPI({ auftragUid: uid, eventId: "" }).unwrap()
              .catch((error) => console.error(error));
          }

        }*/

        props.refresh && props.refresh();
      })
      .catch((error) => console.error("Fehler beim Stornieren des Termins:", error))
      ;
  }

  /*const loginGoogle = useGoogleLogin({
    onSuccess: async (tokenResponse: TokenResponse) => {
      const accessToken = tokenResponse.access_token;
      dispatch(setGoogleToken(accessToken!));
    },
    onError: (err) => console.error('Login fehlgeschlagen', err),
    scope: 'https://www.googleapis.com/auth/calendar',
    flow: 'implicit', // oder 'auth-code' je nach Setup
  });*/

  const submitTerminierung = async (auftrag: IAuftrag) => {

    if (termindatum === undefined) {
      alert("Bitte Datum füllen!");
      return;
    }

    if (stunde === "" || minute === "") {
      alert("Bitte Stunde und Minute auswählen!");
      return;
    }

    if (ausfuehrender === undefined || ausfuehrender === null) {
      alert("Bitte Ausführenden auswählen!");
      return;
    }

    const temptermindatum = termindatum!! + "T" + stunde + ":" + minute + ":00.000Z"

    await setTerminAPI({ uid: auftrag.uid, datumuhrzeit: temptermindatum, uidAusfuehrender: ausfuehrender!.uid })
      .then(() => {

        /*try {

          checkCalendarGoogleToken();
          
          if (googleToken !== null && googleToken !== undefined && calendarId !== undefined && calendarId !== "") {

            const bisStunde: number = parseInt(stunde, 10) + 1;

            const event = {
              summary: auftrag.art + " bei " + auftrag.name_endkunde + " in " + auftrag.stadt_lieferadresse,
              start: { dateTime: termindatum + "T" + stunde + ":" + minute + ":00", timeZone: 'Europe/Berlin' },
              end: { dateTime: termindatum + "T" + bisStunde + ":" + minute + ":00", timeZone: 'Europe/Berlin' },
            };

            if (auftrag.calendarEventId !== null && auftrag.calendarEventId !== "") {

              axios.patch(
                `https://www.googleapis.com/calendar/v3/calendars/${calendarId}/events/${auftrag.calendarEventId}`,
                event,
                {
                  headers: {
                    Authorization: `Bearer ${googleToken}`,
                    "Content-Type": "application/json",
                  },
                }).catch(error => {
                  if (axios.isAxiosError(error)) {
                    //const status = error.response?.status;
                  }
                  console.error(error);
                });

            } else {

              axios.post(
                `https://www.googleapis.com/calendar/v3/calendars/${calendarId}/events`,
                event,
                {
                  headers: {
                    Authorization: `Bearer ${googleToken}`,
                    "Content-Type": "application/json",
                  },
                }
              ).then(response => {
                saveCalendarEventIdAPI({ auftragUid: auftrag.uid, eventId: response.data.id }).unwrap()
                  .catch((error) => console.error(error));
              }).catch(error => {
                if (axios.isAxiosError(error)) {
                  //const status = error.response?.status;
                }
                console.error(error);
              });
            }
          }
        } catch (error) {
          console.log(error);
        }*/

        props.refresh && props.refresh();
        props.statusChanged();

      })
      .catch((e) => {
        console.log(e);
        return;
      })

  }

  useEffect(() => {
    if (ausfuehrender === undefined || ausfuehrender === null || termindatum === undefined || termindatum === null) return;
    getAuftragTermineAPI({ datum: termindatum, profileUid: ausfuehrender.uid }).unwrap().then((data) => {
      setTermineVonAusfuehrenden(data);
    });

  }, [ausfuehrender, termindatum]);

  useEffect(() => {
    lade();
  }, [props.uid_auftrag]);

  useEffect(() => {
    const profileAusfuehrender = userProfiles.find((e) => e.uid === ausfuehrenderUid);
    if (profileAusfuehrender === undefined) return;
    setCalendarId(profileAusfuehrender.calendarId!);
    setAusfuehrender(profileAusfuehrender);
  }, [ausfuehrenderUid]);

  useEffect(() => {
    if (auftrag === undefined) return;

    try {

      if (auftrag?.aktuellerTermin !== null) {
        const aktuellerTermin = new Date(auftrag.aktuellerTermin!!);
        const jahr = aktuellerTermin.getFullYear();
        const monat = (aktuellerTermin.getMonth() + 1).toString().padStart(2, '0');
        const tag = aktuellerTermin.getDate().toString().padStart(2, '0');
        const minute = aktuellerTermin.getMinutes().toString().padStart(2, '0');
        const stunde = aktuellerTermin.getHours().toString().padStart(2, '0');
        setTermindatum(`${jahr}-${monat}-${tag}`);
        setMinute(minute);
        setStunde(stunde);
      }

    } catch (e) {
      console.log(e);
    }
  }, [auftrag]);

  useEffect(() => {
    if (userProfiles === undefined) return;
    if (auftrag === undefined) return;

    var x = auftrag?.ausfuehrungvon && userProfiles.filter((profile) => profile.name === auftrag.ausfuehrungvon?.name);
    if (x != null && x.length > 0) {
      setAusfuehrender(x[0]);
      setAusfuehrenderUid(x[0].uid);
      setCalendarId(x[0].calendarId ?? "");
    }
  }, [userProfiles, auftrag]);

  /*const checkCalendarGoogleToken = async () => {

    if (googleToken === null || googleToken === undefined) return;

    const response = await fetch('https://oauth2.googleapis.com/tokeninfo?access_token=' + googleToken);
    if (!response.ok) {
      loginGoogle();
    } else {
      response.json().then((data) => {
        const myDate = new Date(data.exp * 1000);
        console.log("Google Token ist gültig bis " + myDate.toLocaleString());
      });
    }

  }*/

  useEffect(() => {

    //
    getUserProfiles().unwrap()
      .then(data => {
        setUserProfiles(data);
      });

    //checkCalendarGoogleToken();

  }, []);

  return (
    <>
      {/*<GoogleOAuthProvider clientId={google_clientid} >*/}

        {/*(googleToken === null || googleToken === undefined) &&
          <button className="btn btn-warning" onClick={() => loginGoogle()}>
            <i className='bi bi-exclamation-diamond-fill'></i> Calendar aktivieren <i className='bi bi-exclamation-diamond-fill'></i>
          </button>
        */}

        {calendarId === undefined || calendarId === "" &&
          <div>Kein Kalendar bei Ausführenden hinterlegt</div>
        }
        {auftrag &&
          <>
            {auftrag.aktuellerTermin &&
              <button title='Storno' className="btn btn-danger" onClick={() => stornoTermin(auftrag.uid)}><i className="bi bi-trash"></i> Termin stornieren</button>
            }

            {auftrag.calendarEventId && <div>Auftrag im Calendar vermerkt</div>}

            <form onSubmit={(e) => { e.preventDefault(); submitTerminierung(auftrag); }}>

              <div className="input-group mb-3">
                <label className="input-group-text" htmlFor="selectAusfuehrender">Ausführender:</label>
                <select name="selectAusfuehrender" id="selectAusfuehrender" value={ausfuehrenderUid} onChange={(e) => { setAusfuehrenderUid(e.target.value) }} >
                  <option value={""}>--- Bitte auswählen ---</option>
                  {userProfiles.map((user, index) => {
                    return <option key={index} value={user.uid}>{user.name}</option>;
                  })}
                </select>
              </div>
              <div className="input-group mb-3">
                <label className="input-group-text">Datum:</label>
                <input type="date" style={{ width: "auto", minWidth: "200px" }} name="termindatum" value={termindatum} onChange={handleChangeTermindatum} ></input>
              </div>

              {ausfuehrender !== undefined && ausfuehrender !== null && termindatum !== undefined && termindatum !== null &&
                <>
                  <div>
                    <span>Termine ({termineVonAusfuehrenden.length}):</span>
                    {termineVonAusfuehrenden.map((e, index) => {
                      return <div key={index}>{formatToEuroDateTime(e.datum)} {e.ort}</div>
                    })}
                  </div>
                </>}
              <div className="input-group mb-3">
                <label className="input-group-text">Uhrzeit:</label>
                <select name="stunde" value={stunde ?? ""} onChange={(e) => { e.preventDefault(); setStunde(e.target.value) }}>
                  <option value="07">07</option>
                  <option value="08">08</option>
                  <option value="09">09</option>
                  <option value="10">10</option>
                  <option value="11">11</option>
                  <option value="12">12</option>
                  <option value="13">13</option>
                  <option value="14">14</option>
                  <option value="15">15</option>
                  <option value="16">16</option>
                  <option value="17">17</option>
                  <option value="18">18</option>
                  <option value="19">19</option>
                  <option value="20">20</option>
                  <option value="21">21</option>
                  <option value="22">22</option>
                </select>
                <label className="input-group-text">:</label>
                <select name="minute" value={minute ?? ""} onChange={(e) => { e.preventDefault(); setMinute(e.target.value) }}>
                  <option>00</option>
                  <option>15</option>
                  <option>30</option>
                  <option>45</option>
                </select>
              </div>
              <input disabled={!ausfuehrender || !termindatum} type="submit" className='btn btn-primary' value="Termin speichern" />
            </form>
          </>
        }
     {/* </GoogleOAuthProvider> */}
    </>
  );

}

export default AuftragTerminAendernComponent;